import { DayBookingType } from "../dayBookingType/dayBookingType";
import { DayBookingEntry } from "./dayBooking";
import { DayBookingUsageType, StrMeasureUnit } from "../common/enums";
import { AppUtils } from "../common/appUtils";
import { Base } from "../../framework/common/base";

export function getDurationBasedOnUnit(
    daybooking: DayBookingEntry,
    dayBookingType: DayBookingType,
    onlyOneDay = false
) {
    if (dayBookingType === null) return daybooking.amount;
    if (daybooking.dayUsageType === DayBookingUsageType.FullDay) {
        if (AppUtils.isTimeUnit(dayBookingType.salaryRowTypeMeasureUnit)) {
            return onlyOneDay
                ? dayBookingType.dayHoursRatio
                : daybooking.amount * dayBookingType.dayHoursRatio;
        } else if (onlyOneDay) {
            return 1; // If not time unit, amount for full day is always 1
        }
    } else if (daybooking.dayUsageType === DayBookingUsageType.NotFullDay) {
        if (AppUtils.isTimeUnit(dayBookingType.salaryRowTypeMeasureUnit)) {
            return AppUtils.getDurationStrByDurationMinShort(
                Base.hoursToMinutes(daybooking.amount)
            );
        } else if (
            dayBookingType.salaryRowTypeMeasureUnit ===
            StrMeasureUnit.Piece.toString()
        )
            return daybooking.amount;
        return daybooking.amount / dayBookingType.dayHoursRatio;
    }

    return daybooking.amount;
}
